import { useState } from "react";
import { CSVColumn } from "../config/csvColumns";

export function useCsvExport(columns: CSVColumn[]) {

  const [selectedColumns, setSelectedColumns] = useState<string[]>(
    columns.map((c) => c.key)
  );

  const toggleColumn = (key: CSVColumn["key"]) => {
    setSelectedColumns((prev) =>
      prev.includes(key)
        ? prev.filter((c) => c !== key)
        : [...prev, key]
    );
  };

  const filterRow = (row: any) => {
    const filtered: any = {};

    selectedColumns.forEach((key) => {
      filtered[key] = row[key];
    });

    return filtered;
  };

  return {
    selectedColumns,
    toggleColumn,
    filterRow,
    setSelectedColumns,
  };
}